import { render } from "./SwdErrorBlock.vue?vue&type=template&id=67928250"
import script from "./SwdErrorBlock.vue?vue&type=script&lang=js"
export * from "./SwdErrorBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__